import { getSetting, getSettingLabel } from '@koob/utils';
import ExportDayService from './ExportDayService';

export default function ExportDayServices({
  services,
  extraExperiences,
  settings,
}) {
  const daysSection = getSetting(settings, 'days');
  const servicesSubsection = getSetting(daysSection?.sections, 'day-options');
  const servicesLabel = getSettingLabel(daysSection?.sections, 'day-options');
  const emptyLabel = getSettingLabel(
    servicesSubsection?.fields,
    'day-option-empty',
  );

  const label = (
    <div className="mb-2 text-2xs font-bold uppercase tracking-widest text-[var(--td-primary)]">
      {servicesLabel}
    </div>
  );

  return (
    <div>
      {services?.length > 0 ? (
        <div className="flex flex-col gap-2">
          {services.map((service, index) =>
            index === 0 ? (
              <div
                key={`${service.optionId || service.id}-${index}`}
                data-prevent-cut
              >
                {label}
                <div className="border-l-2 border-[var(--td-primary)] bg-[var(--td-primary-faint)] px-3 py-2">
                  <ExportDayService
                    service={extraExperiences?.[service.optionId ?? service.id]}
                    name={service?.name ?? service?.option?.name}
                  />
                </div>
              </div>
            ) : (
              <div
                key={`${service.optionId || service.id}-${index}`}
                className="border-l-2 border-[var(--td-primary)] bg-[var(--td-primary-faint)] px-3 py-2"
                data-prevent-cut
              >
                <ExportDayService
                  service={extraExperiences?.[service.optionId ?? service.id]}
                  name={service?.name ?? service?.option?.name}
                />
              </div>
            ),
          )}
        </div>
      ) : (
        <div data-prevent-cut>
          {label}
          <div className="text-xs italic text-[var(--td-ink-muted)]">
            {emptyLabel}
          </div>
        </div>
      )}
    </div>
  );
}
